// extracted by mini-css-extract-plugin
export default {"back":"styles_back__FW7p0","icon":"styles_icon__ZW6iN"};